(function () {
  if (window.__b2bCartQtyLoaded) return;
  window.__b2bCartQtyLoaded = true;

  function handleClick(evt) {
    var button = evt.target.closest('.js-qty__adjust--minus, .js-qty__adjust--plus');
    if (!button) return;

    var wrapper = button.closest('.js-qty__wrapper');
    if (!wrapper) return;

    var input = wrapper.querySelector('.js-qty__num');
    if (!input) return;

    var min = parseInt(input.getAttribute('data-qty-min'), 10) || 1;
    var step = parseInt(input.getAttribute('data-qty-step'), 10) || 1;

    if (step <= 1 && min <= 1) {
      // No special B2B rule on this line item; let the theme's own handler run as normal.
      return;
    }

    // This line item has a B2B minimum/increment rule: take over the click
    // entirely so stepping and "remove at minimum" both respect it.
    evt.preventDefault();
    evt.stopImmediatePropagation();

    var current = parseInt(input.value, 10);
    if (isNaN(current)) current = min;

    var next;
    if (button.classList.contains('js-qty__adjust--plus')) {
      next = current + step;
    } else {
      if (current - step >= min) {
        next = current - step;
      } else {
        // Can't step down and stay at/above the minimum: remove the item.
        next = 0;
      }
    }

    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  document.addEventListener('click', handleClick, true);
})();
